import { render, staticRenderFns } from "./PolicyGuidelines.vue?vue&type=template&id=dc35bb5a&scoped=true&"
import script from "./PolicyGuidelines.vue?vue&type=script&lang=ts&"
export * from "./PolicyGuidelines.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyGuidelines.vue?vue&type=style&index=0&id=dc35bb5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc35bb5a",
  null
  
)

export default component.exports